import { useQuery } from '@tanstack/react-query';
import type { GuestNonScriptRangeBundlesProps } from '../../interface/interface';
import Loading from '../Loading';
import GuestProductCards from './GuestProductCards';
import { getGuestBundledAccessories } from '../../service/getGuestBundledAccessories';

export default function GuestNonScriptRangeBundles(
  props: GuestNonScriptRangeBundlesProps,
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['guest-bundled-accessories'],
    queryFn: async () => {
      return await getGuestBundledAccessories();
    },
    retry: 1,
  });

  if (isLoading || props.loading) return <Loading />;

  if (error) {
    console.error('Query error:', error);
    return <p>Error loading bundled accessories</p>;
  }

  return (
    <div className="result-block-container">
      <ul className="grid grid-cols-5 gap-4 xs:grid-cols-1 sm:grid-cols-2 sm-land:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {data?.length ? (
          data?.map((product: any, index: number) => (
            <div key={index}>
              <GuestProductCards
                addProductToCart={async (id: string) => {
                  await props.addToCartMutation.mutateAsync(id);
                }}
                removeProductFromCart={async (productId: string) => {
                  await props.removeFromCartMutation.mutateAsync(productId);
                }}
                product={product}
                substitueCard={false}
                isAccessories={true}
                allowedProduct={false}
                isGuest={true}
              />
            </div>
          ))
        ) : (
          <p>No Non-Script Range Bundled Products Exist</p>
        )}
      </ul>
    </div>
  );
}
